/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { PureComponent } from 'react'
import { Form, Input } from 'semantic-ui-react'

export default class IdentityNumberField extends PureComponent {
  render() {
    const { value, onChange } = this.props

    return (
      <Form.Field required>
        <label>Identity Number</label>
        <Input
          placeholder="e.g 123567890"
          type="number"
          required
          onChange={e => onChange('identity_number', e.target.value)}
          value={value}
        />
      </Form.Field>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/drivers/fields/idNumberField.js